import { matchPath } from "react-router-dom";

export function getDefaultRouteForRole(role) {
  if (role === "driver") return "/driver";
  if (role === "dispatcher") return "/dashboard/courier";
  return "/dashboards/analytics";
}

function routeAllowsRole(route, role) {
  if (route.public) return true;
  if (!route.roles || route.roles.length === 0) return true;
  return !!role && route.roles.includes(role);
}

function filterRouteEntry(route, role, { forNavigation = false } = {}) {
  if (route.collapse) {
    const collapse = route.collapse
      .map((child) => filterRouteEntry(child, role, { forNavigation }))
      .filter(Boolean);

    if (!collapse.length) {
      return null;
    }

    if (forNavigation && route.hiddenInNav) {
      return null;
    }

    return { ...route, collapse };
  }

  if (forNavigation && route.hiddenInNav) {
    return null;
  }

  if (route.route && !routeAllowsRole(route, role)) {
    return null;
  }

  return route;
}

function pruneDecorators(routes) {
  const pruned = [];

  for (const route of routes) {
    if (!route) continue;

    if ((route.type === "divider" || route.type === "title")) {
      const prev = pruned[pruned.length - 1];
      if (!prev || prev.type === "divider" || prev.type === "title") {
        continue;
      }
    }

    pruned.push(route);
  }

  while (pruned.length && (pruned[pruned.length - 1].type === "divider" || pruned[pruned.length - 1].type === "title")) {
    pruned.pop();
  }

  return pruned;
}

export function filterRoutesForRole(routes, role, { forNavigation = false } = {}) {
  return pruneDecorators(
    routes
      .map((route) => filterRouteEntry(route, role, { forNavigation }))
      .filter(Boolean)
  );
}

export function hasMatchingRoute(routes, pathname) {
  return routes.some((route) => {
    if (route.collapse) return hasMatchingRoute(route.collapse, pathname);
    if (!route.route) return false;
    return !!matchPath({ path: route.route, end: true }, pathname);
  });
}

export function canRoleAccessPath(routes, role, pathname) {
  return routes.some((route) => {
    if (route.collapse) return canRoleAccessPath(route.collapse, role, pathname);
    if (!route.route) return false;
    if (!matchPath({ path: route.route, end: true }, pathname)) return false;
    return routeAllowsRole(route, role);
  });
}
